module.exports = __webpack_public_path__ + "img/productWX_8.96f6c158.png";